import React, { useState } from 'react';

import { Button } from 'reactstrap';

// Font Awesome icons.
import { faShareNodes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MainModal from './RegistrationModal';
import ShareModalContent from './ShareModalContent';

function ShareButton({ className = '', buttonLabel = 'Share SFB', ...buttonProps }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const sanitizedClassName = (className ?? '')
    .split(' ')
    .filter(Boolean)
    .filter(token => !/^btn-outline-/.test(token))
    .filter(token => !/^btn-(primary|secondary|success|danger|warning|info|light|dark)$/.test(token))
    .join(' ');

  return (
    <>
      <Button
        data-href="https://www.spitfacebattles.com" 
        data-layout="button_count"
        color="link"
        onClick={openModal}
        className={`fb-share-button btn-share ${sanitizedClassName} text-decoration-none`}
        {...buttonProps}
      >
        <FontAwesomeIcon icon={faShareNodes} size="lg" className="me-2 share-icon" />
        {buttonLabel}
      </Button>

      <MainModal isOpen={isOpen} titleContent="Share Spitface Battles" closeModal={closeModal}>
        <ShareModalContent />
      </MainModal>
    </>
  );
}

export default ShareButton;

